<template>
  <div class="container top-0 position-relative z-index-sticky">
    <div class="row">
      <div class="col-12">
        <navbar v-bind:darkMode="true"
          isBtn="bg-gradient-addiuva"
          isBlur="blur  border-radius-lg my-3 py-2 start-0 end-0 mx-4 shadow"
          />
      </div>
    </div>
  </div>
  <main class="main-content mt-0">
    <div
      class="page-header align-items-start min-vh-50 pt-5 pb-11 m-3 border-radius-lg"
      style="background-image: url('/img/Personal_Assistant-1920x1080-tiny.jpg'); background-position: bottom left;"
    >
      <span class="mask bg-gradient-dark opacity-6"></span>
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-lg-5 text-center mx-auto">
            <h1 class="text-white mb-2 mt-8">Valida tu Afiliación</h1>
            <p
              class="text-lead text-white"
            >Use these awesome forms to login or create new account in your project for free.</p>
          </div>
        </div>
      </div>
    </div>
    <div style="margin-left:6dvw;margin-right:6dvw;">
      <div class="row mt-lg-n10 mt-md-n11 mt-n10 justify-content-center">
        <div class="col-xl-12 col-lg-12 col-md-10 mx-auto">
          <div class="card z-index-0 pr-4 pl-4">
            <validar></validar>
          </div>
        </div>
      </div>
    </div>
  </main>
  <app-footer />
</template>

<script>

import Navbar from "@/examples/PageLayout/Navbar.vue";
import AppFooter from "@/examples/PageLayout/Footer.vue";
import Validar from "./Validar.vue";
const body = document.getElementsByTagName("body")[0];

export default {
  name: "Validacion",
  components: {
    Navbar,
    AppFooter,
    Validar
  },
  created() {
    this.$store.state.hideConfigButton = true;
    this.$store.state.showNavbar = false;
    this.$store.state.showSidenav = false;
    this.$store.state.showFooter = false;
    body.classList.remove("bg-gray-100");
  },
  beforeUnmount() {
    this.$store.state.hideConfigButton = true;
    this.$store.state.showNavbar = true;
    this.$store.state.showSidenav = true;
    this.$store.state.showFooter = true;
    body.classList.add("bg-gray-100");
  },
};
</script>
